import React from 'react';

var GridViewActiveButton = React.createClass({
  getInitialState: function(){
    return { isClicked: true};
  },
  handleClick: function(){
    alert(this.props.value["name"].split("/")[1] + " is already active");  //if already active, then click on it opens alert
  },
  render: function(){
    var classes = "animate__btn";
    if (this.state.isClicked) {
      classes += "  success"
    }
    return(
        <div className="theme-grid__buttons clearfix">
                <a href = "javascript:void(0)" className= {classes} onClick = {this.handleClick}>
                  <span className="btn_1 ">
                     <i className="fa fa-spinner fa-spin"></i> Waiting
                  </span>
                  <span className="btn_2"><strong className="icon"><i className="fa fa-arrow-circle-up"></i> <i className="fa  fa-check-circle"></i></strong> Activate</span>
                  <span className="btn_3"><i className="fa  fa-check-circle"></i> Active</span>
                  Activate
                </a>
        </div>
      );
  }
});


export {GridViewActiveButton};



/** WEBPACK FOOTER **
 ** ./html/components/GridViewActiveButton.jsx
 **/